export default "__VITE_ASSET__CBVIG9ne__"